import { render, staticRenderFns } from "./IntegrationsSection.vue?vue&type=template&id=72f3ef0d&scoped=true&"
import script from "./IntegrationsSection.vue?vue&type=script&lang=js&"
export * from "./IntegrationsSection.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsSection.vue?vue&type=style&index=0&id=72f3ef0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3ef0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
